"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m20 18 2-2V4H2v12l2 2H0v2h24v-2zM4 6h16v10H4z"
}), 'LaptopSharp');